import type { ComboBoxOptionComponentProps } from '../../../cdl/ComboBox/types/ComboBoxComponentProps';
import type { PortOption } from '../PortDetailSelect';
import { PortOptionType } from '../PortOptionType';

import { PortOptionWithoutSchedule } from './PortOptionWithoutSchedule';
import { PortOptionWithSchedule } from './PortOptionWithSchedule';

export const PortSelectOption = ({ option }: ComboBoxOptionComponentProps<PortOption>) => {
    if (option.type === PortOptionType.SCHEDULE) {
        return <PortOptionWithSchedule option={option} />;
    }

    return <PortOptionWithoutSchedule option={option} />;
};
